(function () {
  var C = window.AUREKTO_QC || {};
  var CODE = String(C.code || '').trim().toUpperCase();
  var PCT = parseFloat(C.percent) || 0;
  var ALWAYS = !!C.alwaysInput;
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  if (root.charAt(root.length - 1) !== '/') root += '/';
  var isCart = /\/cart\/?$/.test(location.pathname);
  var LOC = ['/ko-kr/', '/en-kr/', '/ja-jp/', '/en-jp/', '/en-us/', '/en-ap/'];
  var INTERNAL = /^\/(products|collections|pages|blogs|cart|search|account)(\/|$|\?)/;

  function won(cents) { return '\u20a9' + Math.round(cents / 100).toLocaleString('ko-KR'); }
  function el(tag, cls, txt) { var e = document.createElement(tag); if (cls) e.className = cls; if (txt != null) e.textContent = txt; return e; }
  function isVisible(node) {
    if (!node || !node.getClientRects().length) return false;
    var s = getComputedStyle(node);
    return s.visibility !== 'hidden' && s.display !== 'none';
  }

  function fixLinks() {
    if (root === '/') return;
    var prefix = root.slice(0, -1);
    document.querySelectorAll('a[href^="/"]').forEach(function (a) {
      var href = a.getAttribute('href');
      if (!href || href.charAt(1) === '/') return;
      for (var i = 0; i < LOC.length; i++) { if (href.indexOf(LOC[i]) === 0) return; }
      if (!INTERNAL.test(href)) return;
      a.setAttribute('href', prefix + href);
    });
  }

  function steppers() {
    document.querySelectorAll('.aurekto-qty').forEach(function (box) {
      if (box.dataset.qcDone) return;
      var input = box.querySelector('input[name="quantity"]');
      if (!input) return;
      box.dataset.qcDone = '1';
      var wrap = el('div', 'qc-step');
      var minus = el('button', 'qc-step__btn', '\u2212');
      var plus = el('button', 'qc-step__btn', '+');
      minus.type = 'button'; plus.type = 'button';
      minus.setAttribute('aria-label', '\uc218\ub7c9 \uc904\uc774\uae30');
      plus.setAttribute('aria-label', '\uc218\ub7c9 \ub298\ub9ac\uae30');
      input.parentNode.insertBefore(wrap, input);
      wrap.appendChild(minus); wrap.appendChild(input); wrap.appendChild(plus);
      input.classList.add('qc-step__input');
      function bump(d) {
        var n = (parseInt(input.value, 10) || 1) + d;
        if (n < 1) n = 1;
        input.value = n;
        input.dispatchEvent(new Event('change', { bubbles: true }));
      }
      minus.addEventListener('click', function () { bump(-1); });
      plus.addEventListener('click', function () { bump(1); });
    });
  }

  function variantPrice() {
    try {
      var vs = window.ShopifyAnalytics.meta.product.variants;
      var f = document.querySelector('form[data-type="add-to-cart-form"] .product-variant-id');
      var id = f ? parseInt(f.value, 10) : null;
      for (var i = 0; i < vs.length; i++) { if (!id || vs[i].id === id) return vs[i].price; }
    } catch (e) {}
    return null;
  }

  function render(host, cart) {
    host.innerHTML = '';
    var applied = (cart.discount_codes || []).filter(function (d) { return d.applicable; });
    if (applied.length && !ALWAYS) {
      var code = applied[0].code;
      var b = el('div', 'qc-badge');
      b.appendChild(el('span', 'qc-badge__tag', '\ucfe0\ud3f0 ' + code + ' \uc801\uc6a9\ub428'));
      if (isCart) {
        b.appendChild(el('span', 'qc-badge__amt', '\ud560\uc778 \u2212' + won(cart.total_discount)));
      } else {
        var p = variantPrice();
        if (p && PCT > 0 && code === CODE) {
          b.appendChild(el('span', 'qc-badge__amt', '\uacb0\uc81c \uc2dc ' + won(p * (1 - PCT / 100))));
        } else {
          b.appendChild(el('span', 'qc-badge__amt', '\uacb0\uc81c \uc2dc \ud560\uc778 \uc801\uc6a9'));
        }
      }
      host.appendChild(b);
      return;
    }
    var row = el('div', 'qc-row');
    var inp = el('input', 'qc-input');
    inp.type = 'text';
    inp.placeholder = '\ucfe0\ud3f0 \ucf54\ub4dc';
    inp.autocapitalize = 'characters';
    inp.spellcheck = false;
    inp.setAttribute('aria-label', '\ucfe0\ud3f0 \ucf54\ub4dc');
    var btn = el('button', 'qc-apply', '\uc801\uc6a9');
    btn.type = 'button';
    function go() {
      var v = inp.value.trim();
      if (!v) { inp.focus(); return; }
      btn.disabled = true;
      btn.textContent = '\uc801\uc6a9 \uc911';
      location.href = root + 'discount/' + encodeURIComponent(v) + '?redirect=' + encodeURIComponent(location.pathname + location.search);
    }
    inp.addEventListener('keydown', function (e) { if (e.key === 'Enter') { e.preventDefault(); go(); } });
    btn.addEventListener('click', go);
    row.appendChild(inp); row.appendChild(btn);
    host.appendChild(row);
    if (applied.length) {
      host.appendChild(el('p', 'qc-note', '\ucfe0\ud3f0 ' + applied[0].code + ' \uc801\uc6a9\ub428'));
    }
  }

  function mount() {
    var hosts = [];
    if (C.onProduct !== false) {
      document.querySelectorAll('form[data-type="add-to-cart-form"]').forEach(function (f) {
        if (f.querySelector('.qc-host')) return;
        if (!isVisible(f)) return;
        var h = el('div', 'qc-host');
        f.appendChild(h);
        hosts.push(h);
      });
    }
    if (isCart && C.onCart !== false && !document.querySelector('.qc-host--cart')) {
      var btns = Array.prototype.slice.call(document.querySelectorAll('[name="checkout"]'));
      var ck = null;
      for (var i = 0; i < btns.length; i++) { if (isVisible(btns[i])) { ck = btns[i]; break; } }
      if (ck) {
        var anchor = ck.closest('.cart__ctas') || ck.parentNode;
        if (anchor && anchor.parentNode) {
          var h2 = el('div', 'qc-host qc-host--cart');
          anchor.parentNode.insertBefore(h2, anchor);
          hosts.push(h2);
        }
      }
    }
    if (!hosts.length) return;
    fetch(root + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) { hosts.forEach(function (h) { render(h, cart); }); })
      .catch(function () { hosts.forEach(function (h) { render(h, { discount_codes: [], total_discount: 0 }); }); });
  }

  function init() { fixLinks(); steppers(); mount(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();
